<template>
  <div class="noto-sans-sc-font-family">
    <v-card id="product-category-hierarchy" outlined  v-if="isPC()">
      <div class="dp-max-width mx-auto py-5 px-4 font-size-14">
        {{productCategory}}
        <v-icon color="#999999">keyboard_arrow_right</v-icon>
        {{product.subCategory}}
        <v-icon color="#999999">keyboard_arrow_right</v-icon>
        {{product.tinyTitle}}
      </div>
    </v-card>



  

    <div class="faq-menu-wrapper" v-if="isPC()">
      <img src="../assets/pinglun.png" ><span @click="warrantyClick()">Warranty</span><br><br><br>
      <img src="../assets/danbao.png" > <span @click="refundClick()">Review</span><br><br><br>
      <img src="../assets/lianxi.png" > <span @click="share()">Share on Amazon</span><br><br><br>
      <img src="../assets/lianxi.png" > <span @click="cUClick()">Contact Us</span><br><br><br>
      <img src="../assets/bangzu.png" > <span @click="fAQClick()">FAQ</span>
    </div>

      
    <v-container id="product-detail-atf-container" class="pt-11">
      <div id="product-atf" class="dp-max-width mx-auto d-flex justify-space-between flex-wrap">
        <div id="product-images-container">
          <div id="image-display-wrapper">
            <v-img
              class="ma-auto"
              :src="getProductImageSrc(mainImage)"
              width="375px"
              aspect-ratio="1"
              contain
            ></v-img>
          </div>
          <div class="d-flex justify-center flex-wrap" v-if="isPC()" > 
            <v-img
              v-for="(image,index) in product.images"
              :key="index"
              @mouseover="changeMainImage(image)"
              :src="getProductImageSrc(image)"
              max-width="70px"
              max-height="70px"
              :class="imageCssClass(image)"
              class="product-image-smaller mx-1 mt-5 pa-2"
              contain
            ></v-img>
          </div>
        </div>

      <div class="go_warranty_button" v-if="!isPC()">
         <span @click="goWarranty()">Get Warranty</span>
      </div>

        <div id="product-info-container" class="px-2 py-5">
          <div id="product-tinyTitle-block">{{ product.tinyTitle }}</div>
          <v-card
            id="product-full-title-block"
            max-width="416px"
            flat
            class="font-size-14 py-9"
          >{{ product.title }}</v-card>
          <!-- <div id="product-rating-block">
          <v-rating v-model="rating" color="#e2211c" small dense readonly></v-rating>
          </div> -->
          <!-- <div id="product-price-block" class="py-5">{{ currentAmazonListing.displayPrice }}</div> -->
          <div
            id="product-buybutton-block"
            class="d-flex verdana-font-family font-size-14 text-center"
          >
            <!-- <v-card
              color="#e2211c"
              tile
              flat
              class="white--text py-2"
              width="80%"
              :href="currentAmazonDetailPageUrl"
            >Shop on Amazon</v-card> -->
            <!-- <div
              id="purchase-marketplace-switch-wrapper"
              class="d-inline-flex justify-center align-center ml-1 px-3 white--text"
              @mouseover="showMarketplaceDomainMenu"
              @mouseleave="hideMarketplaceDomainMenu"
            > -->
              <!-- <span>{{ getAmazonMarketplaceDomainSuffix(currentAmazonListing.marketplace)}}</span> -->
              <!-- <transition name="slide-fade">
                <div id="makretplace-domain-menu" v-show="marketplaceDomainMenuEnabled">
                  <div
                    class="marketplace-domain-suffix white--text d-flex justify-center align-center my-1 px-3 py-2"
                    v-for="(amazonListing, index) in remainingAvailableAmazonListing"
                    @click="switchAmazonListing(amazonListing)"
                    :key="index"
                  >{{ getAmazonMarketplaceDomainSuffix(amazonListing.marketplace) }}</div>
                </div>
              </transition>
            </div> -->
          </div>
          <div id="product-bullet-points-block" class="mt-11" v-if="isPC()">
            <div class="text-center section-title hidden-sm-and-up">
              <div class="section-title-tab d-inline-block">Features</div>
            </div>
            <ul id="bullet-points" class="font-size-14">
              <li
                v-for="(bulletPoint, index) in product.bulletPoints"
                class="mt-5"
                :key="index"
              >{{ bulletPoint }}</li>
            </ul>
          </div>
        </div>
      </div>
    </v-container>
    <div id="product-detail-intro" class="product-info-section"  v-if="isPC()">
      <div class="text-center section-title">Details</div>
      <div id="product-detail-content">
        <div id="product-detail-image">
          <v-img max-height="400px" contain :src="productOverviewImageSrc"></v-img>
        </div>
        <div
          id="product-detail-description"
          class="mx-auto main-content-width px-2 mt-12"
          v-html="product.description"
        ></div>
      </div>
    </div>
    <div id="product-related-block" class="product-info-section">
      <!-- <div class="text-center section-title">Related Products</div> -->
      <div id="product-related-content-wrapper" class="main-content-width mx-auto">
        <!-- <v-row no-gutters>
          <v-col
            cols="6"
            sm="6"
            md="3"
            v-for="(relatedProduct, index) in relatedProducts"
            :key="index"
          >
            <v-card
              flat
              max-width="95%"
              class="related-product-card mx-auto my-1"
              :href="getProductDetailPageUrl(relatedProduct.id)"
            >
              <v-img
                :src="getImage(relatedProduct.image)"
                max-width="137px"
                contain
                class="pt-9 mx-auto"
              ></v-img>
              <div class="related-product-tinyTitle text-center">{{ relatedProduct.tinyTitle }}</div>
              <div
                class="related-product-price d-flex justify-center align-center py-3 font-size-12"
              >
                {{ relatedProduct.price }}
                <div class="related-product-shopping-cart icon-sprite ml-2"></div>
              </div>
              <div class="related-product-rating text-center pb-5">
                <v-rating v-model="rating" color="#e2211c" small dense readonly></v-rating>
              </div>
            </v-card>
          </v-col>
        </v-row> -->
      </div>
    </div>
  </div>
</template>


<script>
import { getProductInfo } from "../api/dataFactory";
import {
  getAmazonMarketplace,
  getAmazonMarketplaceDomainSuffix
} from "../utils/common";

import { getImage } from "../api/dataFactory";
import staticRelatedProduct from "../mock/staticRelatedProducts";
import router from "../plugins/router";
import bus from '../api/bus';
import { defaultAxiosConfig } from "../api/apiConfig";
export default {
  props: ["id"],
  metaInfo() {
    return {
      title: this.product.title,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.product.title
        },
        {
          vmid: "title",
          name: "title",
          content: this.product.title
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: this.product.title
        }
      ]
    };
  },
  data() {
    return {
      getAmazonMarketplaceDomainSuffix,
      categoryMapping: {
        health: "Health Life",
        smart: "Smart Life"
      },
      getImage,
      product: {},
      mainImage: "",
      rating: 5,
      pageState:1,
      productOverviewImageSrc: "",
      currentAmazonListing: "",
      marketplaceDomainMenuEnabled: false
    };
  },

  //this will increase the dp loading latency, we need to load minimum resource at this method to
  //display the content and load BTF content after the page load
  async beforeRouteEnter(to, from, next) {
    //this need to add logging functionality
    let product = await getProductInfo(to.params.id);
    if (product == undefined) {
      router.replace({ name: "error" });
    }
    next(vm => {
      vm.product = product;
      vm.mainImage = product.images[0];
     
      vm.currentAmazonListing = product.amazonListings[0];
      vm.productOverviewImageSrc = getImage(
        "/product/" + product.id + "/overview.jpg"
      );
    });
  },

  created:function(){
      sessionStorage.setItem("showBoxFlag",true);
   this.productRecord();

   },

 

         beforeDestroy: function () {
     
           sessionStorage.removeItem("productID");
    sessionStorage.setItem("productID",this.product.id);
   
    },


 beforeUpdate:function(){
   
   var flag =sessionStorage.getItem("showBoxFlag");
   if(flag){
    this.warrantyClick(); 
    sessionStorage.removeItem("showBoxFlag");
   }
  
 },
 

  methods: {

     productRecord(){
       var type ="PC";
       if(this.isPC()){
          type="PC";
       }else{
          type="mobile"
       }

        this.$axios({
              url: defaultAxiosConfig.baseURL+"/website/totalData",
              //  url: "http://localhost:5000/website/totalData",
              method: "post",
              params: {"location": "product","type": type}
            }).then(res => {
              window.console.log(res);
            });
     },

    isPC(){
       let flag =navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      if(flag==null){
          return true;
      }else{
        return false;
      }
    },
   
    goWarranty(){
      sessionStorage.removeItem("warrantyState");
      sessionStorage.removeItem("reviewState");
      sessionStorage.removeItem("invitedState");
      sessionStorage.removeItem("cuState");
        var pid =this.product.id;
        sessionStorage.removeItem("pid");
        sessionStorage.setItem("pid",pid);
        sessionStorage.setItem("currentLocation","warrantyModule");
        this.$router.push('/support/warranty');
    },　
    
    fAQClick(){
       this.$router.replace("/support/faq");
    },

    warrantyClick(){
      var pid =this.product.id;
       let  _this = this;
       sessionStorage.removeItem("pid");
      sessionStorage.setItem("pid",pid);
      bus .$emit("entershowBoxGuide",pid);  
      //  this.$router.replace("/support/warranty_register");
    },

    refundClick(){
      var pid =this.product.id;
     
      let  _this = this;
      bus .$emit("showBoxGrade",pid);  
      // this.$router.replace("/support/refund_exchange");
    },

    share(){
       var pid =this.product.id;
      let  _this = this;
      bus .$emit("showBoxShare",pid); 
      //  this.$router.replace("/support/contact_us");
    },


    cUClick(){
       var pid =this.product.id;
       //let.this = this;
       //window.console.log(pid);
      bus .$emit("showBoxCU",pid); 
      //  this.$router.replace("/support/contact_us");
    },

    getProductImageSrc(productImage) {
      if(productImage == undefined){
return "";
      }
      let path = "/product/" + this.product.id + "/" + productImage;
      //window.console.log(path);
      return this.getImage(path);
    },

    changeMainImage(image) {
      this.mainImage = image;
    },

    showMarketplaceDomainMenu() {
      this.marketplaceDomainMenuEnabled = true;
    },

    hideMarketplaceDomainMenu() {
      this.marketplaceDomainMenuEnabled = false;
    },

    switchAmazonListing(amazonListing) {
      this.currentAmazonListing = amazonListing;
      this.marketplaceDomainMenuEnabled = false;
    },

    imageCssClass(image) {
      return image == this.mainImage ? "image-focus" : "image-next";
    },

    getProductDetailPageUrl(id) {
      // return "/product/dp/" + id;
      // return "/product/" + id;
      // return "/p/" + id;
      return "/" + id;
    }
  },

  computed: {
    remainingAvailableAmazonListing() {
      return this.product.amazonListings
        ? this.product.amazonListings.filter(
            listing =>
              listing.marketplace !== this.currentAmazonListing.marketplace
          )
        : [];
    },

    currentAmazonDetailPageUrl() {
      return (
        "//" +
        getAmazonMarketplace(this.currentAmazonListing.marketplace) +
        "" +
        // "/dp/" +
        this.currentAmazonListing.asin
      );
    },

    relatedProducts() {
      return staticRelatedProduct[this.product.subCategory]
        ? staticRelatedProduct[this.product.subCategory].filter(
            relatedProduct => relatedProduct.id != this.product.id
          )
        : [];
    },

    productCategory() {
      return this.categoryMapping[this.product.category];
    }
  }
};
</script>

<style scoped>
.faq-menu-wrapper{
  float: left;
  width: 8%;
  margin-left: 2%;
  margin-top: 10%;
  color: #999999;
}
.faq-menu-wrapper span:hover{
  cursor:pointer ;
  color: #333333;
}
.faq-menu-wrapper img{
  margin-right: 3%;
  width: 9.5%;
}
.pt-11{
  /* margin-left: -5%; */
}
.dp-max-width {
  max-width: 1200px;
}

#product-category-hierarchy {
  border-bottom: 1px solid #e6e6e6;
  border-top: 1px solid #e6e6e6;
  color: #999999;
}

#product-images-container {
  position: sticky;
  width: 44.6%;
  min-width: 200px;
}

#image-display-wrapper {
  padding: 60px;
}

#product-info-container {
  width: 55%;
}
#product-tinyTitle-block {
  text-align: center;
  color: #333333;
  font-size: 30px;
}

#product-full-title-block {
  text-align: center;
  color: #999999;
}

#product-price-block {
  font-size: 24px;
  color: #333333;
}

#product-buybutton-block {
  max-width: 407px;
}

#purchase-marketplace-switch-wrapper {
  background-color: #666666;
  position: relative;
  width: 66px;
}

ul {
  color: #666666;
}

.marketplace-domain-suffix {
  width: 66px;
  background-color: #666666;
  cursor: pointer;
}

#makretplace-domain-menu {
  position: absolute;
  top: 37px;
}

.product-info-section {
  margin-top: 63px;
}

.product-image-smaller {
  border-style: solid;
  border-width: 1px;
  border-color: #666666;
  cursor: pointer;
  border-radius: 3px;
}

.image-focus {
  border-color: #e2211c;
  border-width: 2px;
}

.section-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.11);
  margin-top: 63px;
  margin-bottom: 30px;
  color: #333333;
  font-size: 30px;
  position: relative;
}

.section-title::before {
  position: absolute;
  content: "";
  width: 80px;
  left: 50%;
  transform: translateX(-50%);
  bottom: -3px;
  border-bottom: 4px solid #e2211c;
}

#product-detail-intro {
  color: #666666;
}

.related-product-shopping-cart {
  background-size: 150px;
  width: 17px;
  height: 17px;
  background-position: 0 2px;
}

#purchase-section {
  height: 50px;
}

@media only screen and (max-width: 490px) {
  #product-images-container,
  #product-info-container {
    width: 100%;
  }
}

@media (max-width: 960px) and (min-width: 490px) {
  #image-display-wrapper {
    padding: 30px !important;
  }
}

.related-product-tinyTitle {
  color: #333333;
  font-size: 12px;
}

#product-related-block {
  margin-bottom: 66px;
}

.related-product-card:hover {
  transition: 0.6s;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
}



/* .faq-moblie-menu-wrapper div{
  width: 5em;
  height: 2em;
  float: left;
    text-align: center;
    border-bottom: solid 1px 	#DCDCDC;
} */

.go_warranty_button{
  padding-top: 0.2em;
  font-size: 1.3em;
  color:white;
  /* margin-left: 19%; */
  margin: 0 auto;
  background-color:  #333333;
  width: 10em;
  height: 2em;
  border-radius: 10px;
  text-align: center;  
  margin-bottom: 2.5em;
}


</style>

